// extracted by mini-css-extract-plugin
export var playerWrapper = "index-module--playerWrapper--uLhoX";
export var player = "index-module--player--1fq2l";
export var playerHeadline = "index-module--playerHeadline--ZcyK0";
export var playerTitle = "index-module--playerTitle--abzQG";
export var recipe = "index-module--recipe--ZiGNZ";
export var fadein = "index-module--fadein--1zVsb";